module.exports = __webpack_public_path__ + "img/board.48ddd89.png";